import { useState } from 'react';
import './userRbaMatrix.css';

const QUESTIONS = {
  sanctions_risk: 'Is the client subject to any sanctions, or included in any watch-lists, regulatory or law enforcement lists?',
  pep_risk: 'Is the client a Politically Exposed Person ("PEP")?',
  adversed_media: 'Is the client subject to negative or adverse information?',
  third_country_risk: 'Is the client a third-country national who has applied for citizenship in the Republic?',
  source_of_income: "What is the client's source of income?",
  high_net_worth: 'Is the client a high net worth individual (with a net worth of at least €3M)?',
  risk_sector: 'What is the level of risk of the sector in which the client is employed?',
  residence_country: 'Which is the country of residence of the client?',
  business_country: 'Which is the country where the main place of business of the client is?',
  income_fund_country: 'From which country will the client transfer funds?',
  outcome_fund_country: 'To which country will the client be sending funds?',
  attract_client: 'How was the client attracted?',
  identified_client: 'How is the client identified?',
  third_party_instruction: 'Can a third party give instructions on behalf of the client?',
  anticipated_value: 'What is the anticipated value of the transactions of the client?',
};

const ANSWERS = {
  sanctions_risk: {
    not_matched: 'No matches from Screening via KYC Tool',
    matched: 'Matches found in sanctions / watch-lists',
  },
  pep_risk: {
    not_matched: 'No matches / links with PEP (KYC Tool / public sources)',
    matched: 'PEP or linked to PEP',
  },
  adversed_media: {
    not_matched: 'No negative information found (KYC Tool / public sources)',
    matched: 'Adverse media found',
  },
  third_country_risk: {
    no: 'No',
    yes: 'Yes',
  },
  source_of_income: {
    salary: 'Salary',
    dividend: 'Dividend',
    business_income: 'Business income',
    inheritance: 'Inheritance',
    rental: 'Rental income',
    other: 'Other',
  },
  high_net_worth: {
    no: 'No',
    yes: 'Yes (net worth ≥ €3M)',
  },
  risk_sector: {
    low: 'Low risk sector',
    medium: 'Medium risk sector',
    high: 'High risk sector',
  },
  residence_country: {
    eu: 'EU/EEA',
    EU: 'EU/EEA',
    third_country: 'Third Country',
  },
  business_country: {
    eu: 'EU/EEA',
    EU: 'EU/EEA',
    third_country: 'Third Country',
  },
  income_fund_country: {
    eu: 'EU/EEA',
    EU: 'EU/EEA',
    third_country: 'Third Country',
  },
  outcome_fund_country: {
    eu: 'EU/EEA',
    EU: 'EU/EEA',
    third_country: 'Third Country',
  },
  attract_client: {
    online_marketing: 'Online attraction via marketing without prior communication',
    referral: 'Referral',
    direct: 'Direct contact',
  },
  identified_client: {
    no_face_biometric: 'Non face to face – identification document with biometric lines',
    face_to_face: 'Face to face identification',
    no_face_no_biometric: 'Non face to face – identification document without biometric lines',
  },
  third_party_instruction: {
    no: 'No, only the client can give instructions',
    yes: 'Yes, a third party can give instructions',
  },
  anticipated_value: {
    '0-20': 'Below €15,000',
    '20-50': 'Between €15,001 – €50,000',
    '50-100': 'Between €50,001 – €100,000',
    '>100': 'Above €100,000',
  },
};

const formatAnswer = (key, rawValue) => {
  if (rawValue == null) return '—';
  return ANSWERS[key]?.[rawValue] ?? rawValue;
};

const UserRbaMatrix = ({ userData }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const rba = userData?.rba_quizz;

  if (!rba) return null;

  const { score, rba_risk, answers } = rba;

  return (
    <div className='user_rba_main_div'>
      <div className='user_rba_header' onClick={() => setIsExpanded(prev => !prev)}>
        <p className='user_rba_title'>RBA Matrix :</p>
        <div className='user_rba_summary'>
          <span className='user_rba_score'>Score : <strong>{score?.toFixed(2)}</strong></span>
          <span className={`user_rba_risk_badge user_rba_risk_${rba_risk}`}>{rba_risk?.toUpperCase()}</span>
          <span className='user_rba_chevron'>{isExpanded ? '▲' : '▼'}</span>
        </div>
      </div>

      {isExpanded && answers && (
        <div className='user_rba_answers'>
          {Object.entries(QUESTIONS).map(([key, question]) => (
            <div key={key} className='user_rba_answer_row'>
              <p className='user_rba_question'>{question}</p>
              <p className='user_rba_answer'>{formatAnswer(key, answers[key])}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default UserRbaMatrix;
